import { InjectionToken } from '@angular/core';
import { Embedding } from './shell-protocol';

/**
 * La coque qui encadre l'application, ou `null` quand elle s'utilise seule. Décidé une fois,
 * dans `main.ts`, avant l'initialisation du client de l'annuaire (cadrage 2026-031,
 * RG-acces-ouverture-dans-l-espace-pilotage) ; sans fournisseur, l'application est seule.
 */
export const EMBEDDING = new InjectionToken<Embedding | null>('EMBEDDING', {
  providedIn: 'root',
  factory: () => null,
});
